import { Pipe, PipeTransform } from '@angular/core';
import { Note } from '../../classes/note';

@Pipe({
    name: 'noteUsernameFilter',
    pure: false
})
export class NoteUsernameFilterPipe implements PipeTransform {

    transform(noteList: Array<Note>, filterValue: string): Array<Note> {
        if (!noteList || !filterValue) {
            return noteList;
        }
        const normalizedFilter = filterValue.toLowerCase();
        return noteList.filter(note =>
            (note.user?.Username || '').toLowerCase().indexOf(normalizedFilter) !== -1
        );
    }

}
